import React, { useState, useEffect, useRef } from 'react';

// Blue Cursor Trail Effect - Fixed Visibility & Flickering
const CursorTrail = () => {
  const [cursorPos, setCursorPos] = useState({ x: 0, y: 0 });
  const [followerPos, setFollowerPos] = useState({ x: 0, y: 0 });
  const [isHovering, setIsHovering] = useState(false);
  const rafIdRef = useRef(null);

  useEffect(() => {
    let mouseX = 0;
    let mouseY = 0;
    let followerX = 0;
    let followerY = 0;

    const handleMouseMove = (e) => {
      mouseX = e.clientX;
      mouseY = e.clientY;
      
      // Check if hovering over interactive elements
      const target = e.target;
      const isInteractive = target.matches('a, button, input, textarea, select, [role="button"], .cursor-pointer');
      setIsHovering(isInteractive);
    };

    const animate = () => {
      // Smooth following effect for the large circle
      followerX += (mouseX - followerX) * 0.15;
      followerY += (mouseY - followerY) * 0.15;

      // Update positions
      setCursorPos({ x: mouseX, y: mouseY });
      setFollowerPos({ x: followerX, y: followerY });

      rafIdRef.current = requestAnimationFrame(animate);
    };

    window.addEventListener('mousemove', handleMouseMove, { passive: true });
    rafIdRef.current = requestAnimationFrame(animate);

    return () => {
      window.removeEventListener('mousemove', handleMouseMove);
      if (rafIdRef.current) {
        cancelAnimationFrame(rafIdRef.current);
      }
    };
  }, []);

  return (
    <>
      {/* Following circle - large blue circle with smooth trail */}
      <div
        className={`fixed pointer-events-none z-[9999] rounded-full transition-transform duration-200 ${
          isHovering ? 'scale-150' : 'scale-100'
        }`}
        style={{
          left: `${followerPos.x - 20}px`,
          top: `${followerPos.y - 20}px`,
          width: '40px',
          height: '40px',
          border: '2px solid rgba(59, 130, 246, 0.8)',
          willChange: 'transform',
        }}
      />
      
      {/* Small inner dot - follows cursor immediately */}
      <div
        className="fixed pointer-events-none z-[9999] rounded-full"
        style={{
          left: `${cursorPos.x - 4}px`,
          top: `${cursorPos.y - 4}px`,
          width: '8px',
          height: '8px',
          backgroundColor: '#3b82f6',
          willChange: 'transform',
        }}
      />
    </>
  );
};

export default CursorTrail;
